import { normalizePosition } from './normalize-position';

const KEYBOARD_NUDGE_PERCENT = 5;
const DEFAULT_POSITION = { x: 50, y: 50 };

export const getNextPositionByPressedKey = (key, position) => {
  const step = KEYBOARD_NUDGE_PERCENT;

  switch (key) {
    case 'ArrowLeft':
      return normalizePosition({ ...position, x: position.x - step });
    case 'ArrowRight':
      return normalizePosition({ ...position, x: position.x + step });
    case 'ArrowUp':
      return normalizePosition({ ...position, y: position.y - step });
    case 'ArrowDown':
      return normalizePosition({ ...position, y: position.y + step });
    case 'Escape':
      return DEFAULT_POSITION;
    default:
      return null;
  }
};
